import { OrderPlacementAction, OrderPlacementActionKind, OrderPlacementState } from './constants';
import { HYDRATE } from 'next-redux-wrapper';

const initialState: OrderPlacementState = {
  slots: [],
  vehicleProducts: [],
  products: [],
  carbuyersDetails: null,
  stnkDetails: null,
  merchants: [],
  leasingCompanies: [],
  selectedLeasing: null,
  paymentMode: {
    paymentType: null,
    paymentDetails: null,
    shipmentInformation: null,
    bookingFee: null,
  },
  cartCode: '',
  carShipmentMethod: '',
  shippingMethod: '',
  loanRequestParams: null,
  formKtp: null,
  formKtpStnk: null,
  astrapayBalance: null,
  selectedExpedition: null,
  noBookingServiceUuids: [],
};

function orderPlacementReducer(
  state = initialState,
  action: OrderPlacementAction
): OrderPlacementState {
  switch (action.type) {
    case HYDRATE:
      return { ...state, ...action.payload.orderPlacement };
    case OrderPlacementActionKind.SET_BRANCH:
      if (action.branch) {
        return {
          ...state,
          slots: [],
          shippingMethod: '',
          branch: action.branch,
        };
      }
      return state;

    case OrderPlacementActionKind.SET_BUYER_INFO:
      return {
        ...state,
        buyer: action.buyer,
      };

    case OrderPlacementActionKind.SET_PRODUCTS:
      if (action.products) {
        return {
          ...state,
          products: [...action.products],
        };
      }
      return state;

    case OrderPlacementActionKind.SET_CARBUYER_DETAILS:
      if (action.carbuyersDetails) {
        return {
          ...state,
          carbuyersDetails: action.carbuyersDetails,
        };
      }
      return state;

    case OrderPlacementActionKind.SET_STNK_DETAILS:
      if (action.stnkDetails) {
        return {
          ...state,
          stnkDetails: action.stnkDetails,
        };
      }
      return state;

    case OrderPlacementActionKind.SET_MERCHANTS:
      if (action.merchants) {
        return {
          ...state,
          merchants: [...action.merchants],
        };
      }
      return state;

    case OrderPlacementActionKind.SET_LEASING_COMPANIES:
      if (action.leasingCompanies) {
        return {
          ...state,
          leasingCompanies: action.leasingCompanies,
        };
      }
      return state;

    case OrderPlacementActionKind.SET_SELECTED_LEASING:
      if (action.selectedLeasing) {
        return {
          ...state,
          selectedLeasing: action.selectedLeasing,
        };
      }
      return state;

    case OrderPlacementActionKind.SET_PAYMENT_MODE:
      if (action.paymentMode) {
        return {
          ...state,
          paymentMode: action.paymentMode,
        };
      }
      return state;

    case OrderPlacementActionKind.SET_SLOTS: {
      return { ...state, slots: action.slots };
    }

    case OrderPlacementActionKind.SET_VEHICLE_PRODUCTS: {
      return { ...state, vehicleProducts: action.vehicleProducts };
    }

    case OrderPlacementActionKind.SET_CART_CODE:
      return { ...state, cartCode: action.cartCode };

    case OrderPlacementActionKind.SET_SHIPMENT:
      return { ...state, shipment: action.shipment };

    case OrderPlacementActionKind.SET_LOAN_REQUEST_PARAMS:
      return { ...state, loanRequestParams: action.loanRequestParams };
    case OrderPlacementActionKind.SET_CAR_SHIPMENT_METHOD:
      return { ...state, carShipmentMethod: action.carShipmentMethod || '' };
    case OrderPlacementActionKind.SET_SHIPPING_METHOD: {
      if (action.shippingMethod === '') {
        return { ...state, shipment: undefined, shippingMethod: action.shippingMethod };
      } else if (action.shippingMethod === 'AMBIL DI CABANG') {
        return {
          ...state,
          shipment: {
            orderPreference: 'P1',
          },
          shippingMethod: action.shippingMethod,
        };
      } else if (action.shippingMethod === 'PASANG DI CABANG') {
        return {
          ...state,
          shipment: {
            orderPreference: 'P2',
          },
          shippingMethod: action.shippingMethod,
        };
      }
      return { ...state, shippingMethod: action.shippingMethod };
    }
    case OrderPlacementActionKind.SET_SEAMLESS_DATA:
      return { ...state, seamlessData: action.seamlessData };

    case OrderPlacementActionKind.SET_FORM_KTP:
      return { ...state, formKtp: action.formKtp };

    case OrderPlacementActionKind.SET_FORM_KTP_STNK:
      return { ...state, formKtpStnk: action.formKtpStnk };

    case OrderPlacementActionKind.SET_ASTRAPAY_BALANCE:
      return { ...state, astrapayBalance: action.astrapayBalance };

    case OrderPlacementActionKind.RESET_STATE:
      return initialState;

    case OrderPlacementActionKind.SET_SELECTED_EXPEDITION:
      return {
        ...state,
        selectedExpedition: action.selectedExpedition,
      };

    case OrderPlacementActionKind.SET_NO_BOOKING_SERVICE_UUIDS:
      return {
        ...state,
        noBookingServiceUuids: action.noBookingServiceUuids || [],
      };

    default:
      return state;
  }
}

export default orderPlacementReducer;
